import { render, staticRenderFns } from "./StockWarning.vue?vue&type=template&id=574d13c3&scoped=true&"
import script from "./StockWarning.vue?vue&type=script&lang=ts&"
export * from "./StockWarning.vue?vue&type=script&lang=ts&"
import style0 from "./StockWarning.vue?vue&type=style&index=0&id=574d13c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d13c3",
  null
  
)

export default component.exports